export const tokens = {
    podName: {
        fontSize: {
            mobile: 20,
            tablet: 36,
            desktop: 48,
        },
        // TODO: Why does this change only for `tablet`?
        lineHeight: {
            mobile: 1,
            tablet: 1.2,
            desktop: 1,
        },
    },
    editableName: {
        padding: 10,
        radius: 10,
    },
};
